import React from 'react';
export function MarqueeBar() {
  return <div className="fixed top-0 left-0 w-full bg-[#00A86B] text-white py-2 z-50 overflow-hidden marquee-container shadow-md" data-id="element-167">
      <div className="whitespace-nowrap flex" data-id="element-168">
        {/* Duplicate content for seamless looping */}
        <div className="animate-marquee flex-shrink-0 flex items-center" data-id="element-169">
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-170">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-171">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-172">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-173">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
        </div>
        <div className="animate-marquee flex-shrink-0 flex items-center" aria-hidden="true" data-id="element-174">
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-175">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-176">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-177">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-178">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
        </div>
      </div>
    </div>;
}